<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Pré-inscrições</span>
      <span class="titulo-contexto">
        Cada campanha tem grupos por faixa etária e um link público. Quem se inscreve informa a data
        de nascimento e cai no grupo da idade dela — não escolhe grupo.
      </span>
    </div>
    <button nbButton status="primary" size="medium" class="btn-primario-crud" (click)="abrirDialog()">
      <nb-icon pack="eva" icon="clipboard-outline" class="icone-primario-crud"></nb-icon>
      <span>Adicionar campanha</span>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar">
      <div class="filtro-toolbar-inline">
        <div class="filtro-turma-full">
          <label class="field-label" for="preInscricaoFiltro">Pesquisa</label>
          <nb-form-field>
            <nb-icon nbPrefix pack="eva" icon="search-outline"></nb-icon>
            <input
              nbInput
              fullWidth
              id="preInscricaoFiltro"
              name="preInscricaoFiltro"
              placeholder="Nome da campanha — Enter para buscar"
              [(ngModel)]="filtro"
              (keyup.enter)="buscarAgora()"
            />
          </nb-form-field>
        </div>
        <div class="campo-filtro--acoes">
          <button nbButton status="basic" size="small" type="button" (click)="buscarAgora()" title="Buscar agora" aria-label="Buscar agora">
            <nb-icon pack="eva" icon="search-outline"></nb-icon>
          </button>
        </div>
      </div>
    </div>

    <app-barra-carregando *ngIf="carregando"></app-barra-carregando>

    <div class="smart-table-wrap" *ngIf="campanhas.length">
      <table class="smart-table">
        <thead>
          <tr>
            <th appOrdenavel campo="nome" rotuloAcessivel="Nome" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Nome</th>
            <th appOrdenavel campo="dataReferenciaIdade" rotuloAcessivel="Idade apurada em" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Idade apurada em</th>
            <th appOrdenavel campo="ativa" rotuloAcessivel="Situação" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Situação</th>
            <th class="col-num">Grupos</th>
            <th class="col-num">Inscritos / vagas</th>
            <th class="col-acoes col-acoes--icones">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of campanhas">
            <td data-label="Nome">{{ c.nome }}</td>
            <td data-label="Idade apurada em">{{ c.dataReferenciaIdade ? (c.dataReferenciaIdade + 'T00:00:00' | date: 'dd/MM/yyyy') : '—' }}</td>
            <td data-label="Situação">
              <span class="tag-situacao" [class.tag-situacao--encerrada]="!c.ativa">
                {{ c.ativa ? 'No ar' : 'Encerrada' }}
              </span>
              <!-- PRE-15: no ar, mas recusando todo mundo por falta de horário com lugar. -->
              <button
                type="button"
                class="tag-sem-horario"
                *ngIf="c.id && semHorario.has(c.id)"
                (click)="abrirAgendas(c)"
                title="Sem horário de atendimento futuro com lugar: o link público recusa toda pré-inscrição"
              >
                <nb-icon pack="eva" icon="alert-triangle-outline"></nb-icon>
                Sem horário com lugar
              </button>
            </td>
            <td class="col-num" data-label="Grupos">{{ c.grupos?.length || 0 }}</td>
            <td class="col-num" data-label="Inscritos / vagas">{{ ocupacao(c) }}</td>
            <td class="col-acoes col-acoes--icones" data-label="Ações">
              <div class="acao-btns acao-btns--inline" role="group">
                <button type="button" nbButton size="small" appearance="outline" status="info" class="btn-acao"
                  (click)="abrirGrupos(c)" title="Grupos e vagas" aria-label="Grupos e vagas desta campanha">
                  <nb-icon pack="eva" icon="layers-outline"></nb-icon>
                </button>
                <button type="button" nbButton size="small" appearance="outline" status="info" class="btn-acao"
                  (click)="abrirAgendas(c)" title="Horários de atendimento" aria-label="Horários de atendimento desta campanha">
                  <nb-icon pack="eva" icon="clock-outline"></nb-icon>
                </button>
                <button type="button" nbButton size="small" appearance="outline" status="primary" class="btn-acao"
                  (click)="abrirInscritos(c)" title="Quem se pré-inscreveu" aria-label="Quem se pré-inscreveu nesta campanha">
                  <nb-icon pack="eva" icon="people-outline"></nb-icon>
                </button>
                <button type="button" nbButton size="small" appearance="outline" status="basic" class="btn-acao"
                  (click)="copiarLink(c)" title="Copiar o link público" aria-label="Copiar o link público desta campanha">
                  <nb-icon pack="eva" icon="link-2-outline"></nb-icon>
                </button>
                <button type="button" nbButton size="small" appearance="outline" status="basic" class="btn-acao"
                  (click)="editar(c)" title="Editar campanha" aria-label="Editar campanha">
                  <nb-icon pack="eva" icon="edit-outline"></nb-icon>
                </button>
                <button type="button" nbButton size="small" appearance="outline" [status]="c.ativa ? 'warning' : 'success'" class="btn-acao"
                  [disabled]="salvandoId === c.id" [nbSpinner]="salvandoId === c.id"
                  (click)="alternarAtiva(c)"
                  [title]="c.ativa ? 'Encerrar: o link público para de aceitar envios' : 'Reabrir a campanha'"
                  [attr.aria-label]="c.ativa ? 'Encerrar campanha' : 'Reabrir campanha'">
                  <nb-icon pack="eva" [icon]="c.ativa ? 'slash-outline' : 'checkmark-circle-2-outline'"></nb-icon>
                </button>
                <button type="button" nbButton size="small" appearance="outline" status="danger" class="btn-acao"
                  (click)="excluir(c)" title="Excluir campanha" aria-label="Excluir campanha">
                  <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-lista-vazia
      *ngIf="!carregando && !campanhas.length"
      icone="clipboard-outline"
      [filtrado]="temFiltro"
      mensagem="Nenhuma campanha de pré-inscrição cadastrada. Crie uma para gerar o link público."
      mensagemFiltrado="Nenhuma campanha casa com o recorte atual."
      (verTodos)="limparFiltro()"
    ></app-lista-vazia>

    <div class="lista-paginacao" *ngIf="totalPages > 0">
      <button nbButton size="small" [disabled]="page === 1" (click)="onPageChange(page - 1)">Anterior</button>
      <span>Página {{ page }} de {{ totalPages }}</span>
      <button nbButton size="small" [disabled]="page === totalPages" (click)="onPageChange(page + 1)">Próxima</button>
    </div>
  </nb-card-body>
</nb-card>
